import { useMemo } from 'react';
import { useParams } from 'react-router';
import { useGetVehicleQuery } from '../../../api/queries/getVehicle';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import VariantDetailsPage from './VariantDetailsPage';

const VariantDetails = () => {
    const { variantId } = useParams<{ variantId: string }>();

    const { data, loading } = useGetVehicleQuery({
        fetchPolicy: 'network-only',
        variables: { id: variantId },
    });

    const variant = useMemo(() => {
        if (data?.vehicle?.__typename !== 'LocalVariant') {
            return null;
        }

        return data.vehicle;
    }, [data]);

    if (!variant && loading) {
        return <LoadingElement />;
    }

    if (!variant) {
        return <NotFoundResult />;
    }

    return <VariantDetailsPage variant={variant} />;
};

export default VariantDetails;
